export default __webpack_public_path__ + "ba3a09d200657a34f07de06a4bc7d21e.svg";